import React from 'react';

import { hashCode } from 'core/util';
import { StyleUtil } from 'ui/util';
import { CaseTabContentContainer } from '../case-tab-content-container';
import classNames from './EABD2CaseBenefitsTabContent.module.scss';

export interface CaseBenefitsTabContentProps
  extends Readonly<{
    items: string[];
  }> {}

export const CASE_BENEFIT_EMPHASIZED_TEMPLATE_STRING = '{em}';

export const CASE_BENEFIT_EM_TAG_OPEN = '<em>';
export const CASE_BENEFIT_EM_TAG_CLOSE = '</em>';
export const CASE_BENEFIT_SPECIAL_SPACE_CHARACTER = '|';

export const CaseBenefitsTabContent = React.memo<CaseBenefitsTabContentProps>((props) => {
  const { items } = props;

  const RenderWordCallback = React.useCallback((word: string, index: number, numberOfWords: number, itemIndex: number) => {
    const isLastWord = index === numberOfWords - 1;
    const isWordStartsWithEmTag = word.startsWith(CASE_BENEFIT_EM_TAG_OPEN);
    const isWordEndsWithEmTag = word.endsWith(CASE_BENEFIT_EM_TAG_CLOSE);
    const isWordWithinEmTags = isWordStartsWithEmTag && isWordEndsWithEmTag;

    if (isWordWithinEmTags) {
      const emphasizedWord = word
        .replace(CASE_BENEFIT_EM_TAG_OPEN, '')
        .replace(CASE_BENEFIT_EM_TAG_CLOSE, '')
        .split(CASE_BENEFIT_SPECIAL_SPACE_CHARACTER)
        .join(' ');

      return (
        <React.Fragment key={`${hashCode(word)}-${index}-${itemIndex}`}>
          <span className={classNames.emphasized}>{emphasizedWord}</span>
          {!isLastWord && ' '}
        </React.Fragment>
      );
    }

    return (
      <React.Fragment key={`${hashCode(word)}-${index}-${itemIndex}`}>
        {word}
        {!isLastWord && ' '}
      </React.Fragment>
    );
  }, []);

  const RenderItemCallback = React.useCallback(
    (item: string, index: number) => {
      const words = item.split(' ');
      const numberOfWords = words.length;
      const renderWordCallback = (word: string, wordIndex: number) =>
        RenderWordCallback(word, wordIndex, numberOfWords, items.indexOf(item));

      const listItemClassNames = StyleUtil.createInitialClassNameArray(classNames.listItem);
      listItemClassNames.push(items.length % 2 === 0 ? classNames.evenItemCount : classNames.oddItemCount);

      return (
        <div key={`${hashCode(item)}-${index}`} className={StyleUtil.mergeClassNames(listItemClassNames)}>
          <div className={classNames.lisItemSymbol} />
          <p className={classNames.text}>{words.map(renderWordCallback)}</p>
        </div>
      );
    },
    [items, RenderWordCallback]
  );

  return (
    <CaseTabContentContainer>
      <div className={classNames.list}>{items.map(RenderItemCallback)}</div>
    </CaseTabContentContainer>
  );
});
